import { loadScript } from '../../utils/Dom';
import PlayerProxy from '../PlayerProxy';
import { PlayerEvent } from '../../PlayerEvents';
import { KV } from '../../core/Constant';
import { removeFromParent } from '../../utils/Dom';
import log from 'loglevel';
import { RTLConfig } from '../../config';
import { systemProbe } from '../../utils/util';

export default class TxrtcPlayer extends PlayerProxy {
  constructor(opt = {}) {
    super(opt);
    this.TAG = 'Txrtc';
    this._type = 'Txrtc';
    this._systemProbe = systemProbe();
    this.livePlayer = null;
  }

  async initVideo(option = {}) {
    super.initVideo(option);
    if (option.autoplay) {
      this.video.setAttribute('autoplay', 'autoplay');
    }
    let autodegrade = true; //默认支持腾讯快直播内核降级
    if (option.hasOwnProperty('liveOption') && option.liveOption.hasOwnProperty('autodegrade')) {
      autodegrade = option.liveOption.autodegrade;
    }

    try {
      await loadScript('TXLivePlayer', RTLConfig.tx.url);
    } catch (err) {
      log.error('TXLivePlayer sdk load error: ' + err.message);
    }

    this.livePlayer = new TXLivePlayer();
    this.livePlayer.setPlayerView(this.videoID);

    const that = this;
    //TXLivePlayer回调事件  https://webrtc-demo.myqcloud.com/pull-sdk/docs/TXLivePlayer.html#~onPlayEvent
    this.livePlayer.setPlayListener({
      // play event
      onPlayEvent: function (code, data) {
        log.info(code + '-------------------', data);
        //PLAY_ERR_WEBRTC_FAIL	-2001	WebRTC 相关错误（⽐如浏览器不⽀持 WebRTC、设置 sdp 失败等）  降级
        //PLAY_ERR_REQUEST_PULL_FAIL	-2002	拉流接⼝后台返回报错（⽐如流不存在、鉴权失败等）        降级
        //PLAY_ERR_PLAY_FAIL	-2003	视频播放失败                          浏览器禁止自动播放      不降级
        //PLAY_ERR_SERVER_DISCONNECT	-2004	连接服务器失败，并且连接重试次数已超过设定值            降级
        //PLAY_ERR_DECODE_FAIL	-2005	视频解码失败                                               降级
        //PLAY_ERR_REQUEST_ABR_FAIL	-2006	多分辨率平滑切换接口请求失败                            降级
        if (autodegrade && [-2001, -2002, -2004, -2005, -2006].includes(code)) {
          //降级
          that.changeKernel({
            code: code,
            message: 'changeKernel'
          });
        }

        // if (code === -2003 && data.message.includes('NotAllowedError')) {
        //   console.log("自动播放受限导致播放失败，此时引导用户点击页面");
        //   // 在点击事件的回调函数中，执行 livePlayer.resume()
        // }
      },
      // WebRTC statistics data
      onPlayStats: function (data) {
        let bitrate = data.video.bitrate; //视频码率
        let framesReceived = data.video.framesReceived; //接收帧数
        let framesDecoded = data.video.framesDecoded; // 解码帧数

        //降级  有数据，接收帧率大于90，没有渲染帧
        if (autodegrade && bitrate && framesReceived > 90 && framesDecoded <= 0) {
          log.info('10000-------------------', data);
          that.changeKernel({
            code: 10000,
            message: 'bitrate:' + bitrate + '; framesReceived:' + framesReceived + '; framesDecoded:' + framesDecoded
          });
        }
      }
    });
  }

  setMuted(b) {
    //问题：鸿蒙系统浏览器下快直播，操作静音无效
    //反馈：您好，我们复现了，看起来是鸿蒙系统的问题，看起来setMute 不会立即生效，下一次的 setVolume 会使得 setMute 生效
    super.setMuted(b);
    if(b){
      this.livePlayer.setVolume(0);
    } else {
      this.livePlayer.setVolume(100);
    }
  }

  getEstimateNetSpeed() {}

  getDownloadSize() {}
  changeKernel(event) {
    if (this.livePlayer) {
      this.livePlayer.stopPlay().then(() => {
        this.livePlayer.destroy();
        this.livePlayer = null;
        this.destroy();
        this.emit2All(PlayerEvent.CHANGEKERNEL, event);
      });
    }
  }
  setSrc(url) {
    if (this.getStore().getKV(KV.URL)) {
      //停止当前流，切换新流地址
      this.livePlayer.stopPlay().then(() => {
        this.changeSrc(url);
      });
    } else {
      this.changeSrc(url);
    }
  }
  changeSrc(url) {
    if (this._isPlayingBefore === undefined) {
      this._isPlayingBefore = this._isPlaying;
      this._isPlaying = false;
    }

    const e = {
      oldValue: this._src,
      newValue: url
    };

    this.emit2All(PlayerEvent.SRC_CHANGED, e);
    this.getStore().setKV(KV.URL, url);
    this._setSrcCount += 1;
    this.livePlayer.setConfig({ receiveVideo: true, receiveAudio: true });
    if (url.indexOf('_a?') > -1) {
      //判断音频流，关闭视频接收
      this.livePlayer.setConfig({ receiveVideo: false, receiveAudio: true });
    }

    this.livePlayer.startPlay(url);
  }
  destroy() {
    window.peer5 && window.peer5.destroy();
    this._volume = 0.5;
    this._src = '';
    this._isLive = false;
    this._isPlaying = false;
    this.getStore().reset();
    this.reset();

    if (this.video) {
      Object.keys(this.videoEventList).forEach(key => {
        this.video.removeEventListener(key, this.videoEventList[key]);
      });

      removeFromParent(this.video);
      this.video = null;
    }
  }
}
